export default "__VITE_ASSET__bRLpvylG__"